module.exports = __webpack_public_path__ + "f1d0da82c59774f397c4db4a9e79399c.png";